module.exports = __webpack_public_path__ + "img/pro-5-gen-portrait.53378a9.png";